'use client';

import {useState} from 'react';
import {useTranslations} from 'next-intl';
import Button from '../ui/Button';

export default function NewsletterSection() {
  const t = useTranslations('newsletter');
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    try {
      await fetch('/api/v1/newsletter/subscribe', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email}),
      });
      setSubscribed(true);
    } catch { setSubscribed(true); }
  }

  return (
    <section className="bg-rose-pale py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-primary mb-3">
          {t('title')}
        </h2>
        <p className="text-muted mb-8 max-w-xl mx-auto">
          {t('description')}
        </p>

        {subscribed ? (
          <div className="bg-white rounded-xl p-6 inline-block">
            <svg className="w-10 h-10 text-primary mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <p className="text-primary font-semibold">{t('success')}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <input
              type="email"
              placeholder={t('placeholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 py-3 rounded-lg border border-border bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition"
              required
            />
            <Button type="submit" variant="primary" size="md">
              {t('subscribe')}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
